




import Vue from 'vue'

export default Vue.extend({
  name: 'IndexColumn',
  props: {
    scope: Object as () => {
      pagination: {
        pageSize: number
        currentPage: number
        totalItems: number
      }
    },
    rowIndex: Number
  },
  computed: {
    recordNumber (): number {
      return this.scope.pagination.currentPage * this.scope.pagination.pageSize - this.scope.pagination.pageSize + this.rowIndex + 1
    }
  }
})
